import { BluetoothOffIcon } from './BluetoothOffIcon';

/**
 * author: Google
 * id CEB015C9-455E-4551-A898-7A992658CF72
 * name bluetooth-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bluetooth-off.svg
 * tags
 */
export const BluetoothDisabledIcon = BluetoothOffIcon;
export default BluetoothDisabledIcon